// 获取公司地址
let cAddr = '上海市闵行区七莘路1599弄平金中心6号楼5F'
// const cAddr = '上海市闵行区顾戴路2959号中展大厦3F'

export default cAddr;


// WEBPACK FOOTER //
// ./src/assets/script/comAddress.js